import { render, staticRenderFns } from "./VideoPlayerSimple.vue?vue&type=template&id=af2a2bb2&"
import script from "./VideoPlayerSimple.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerSimple.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerSimple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports